import { ReactElement } from 'react';
import { IconsMap } from '@nx-frontend/shared/ui/icon';
import { FileType } from '@nx-frontend/shared/types';

export const getIconByFileType = (fileKind: FileType): ReactElement => {
  const fileIconsMap: Record<FileType, ReactElement> = {
    [FileType.IMAGE]: IconsMap.IMAGE_FILL,
    [FileType.DOC]: IconsMap.DOCUMENT_FILL,
    [FileType.FILE]: IconsMap.FILE_FILL,
    [FileType.ARCHIVE]: IconsMap.ARCHIVE_FILL,
    [FileType.AUDIO]: IconsMap.AUDIO_FILL,
    [FileType.VIDEO]: IconsMap.VIDEO_FILL,
  };

  return fileIconsMap[fileKind] || IconsMap.FILE;
};
